import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useThrottle } from "../../../../hooks/useThrottle"
import { useSearchByUsernameQuery } from "../../../../store/accountSlice"
import { BaseViewModel } from "./Base"
import type {
    SearchUsersViewModel,
    SearchUsersViewModelPros,
} from "./SearchUsersViewModelTypes"

export const UnifiedViewModel = ({
    typingThrottle,
}: SearchUsersViewModelPros): SearchUsersViewModel => {
    const navigate = useNavigate()
    const [search, setSearch] = useState<string>("")
    const throttledFilter = useThrottle(search, typingThrottle)

    const { data, isFetching, error } = useSearchByUsernameQuery(
        { term: throttledFilter },
        {
            skip: !throttledFilter,
        },
    )

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value)
    }

    const handleUserSelect = (username: string) => {
        navigate(`/messages/${username}`)
    }

    const { listRef, source } = BaseViewModel()

    return {
        searchResults: {
            search,
            setSearch,
            isFetching,
            error,
            data,
        },
        listRef,
        source,
        handleSearchChange,
        handleUserSelect,
    }
}
